<template lang="pug">
  v-checkbox(class="reading-mark" v-model="value.mark_reading" label="Прочитал(а)" disabled)
</template>

<script>
export default {
  name: 'TypeMark',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
